<template>
  <div class="switcher" :class="{checked: ownValue, disabled: disabled}" @click="ownValue = !ownValue">
    <div class="switcher__slider" />
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ownValue: {
      get() {
        return this.disabled ? false : this.value
      },
      set (to) {
        if (this.disabled) return
        this.$emit('change', to)
      }
    }
  }
}
</script>

<style lang="stylus">
.switcher
  height: vh(34px)
  margin: auto
  padding-right: vw(15px)
  position: relative
  width: vw(30px)

  .mobile &
    margin-right: vw(14px)
    width: vw(28px)

    +m-breakpoint(landscape)
      height: vh(20px)
      margin-right: 0px
      width: vw(20px)

  &:hover
    &:not(.disabled)
      .switcher__slider
        background-color: rgba($blue-2, 0.5)

        &:before
          box-shadow: 0 0.5px 4px rgba(#000, 0.25), 0 6px 13px rgba(#000, 0.25)

  &.disabled
    cursor: default
    opacity: 0.5

    .switcher__slider
      cursor: default

  &.checked
    .switcher__slider
      background-color: $blue-2

      &:before
        transform: translate(75%, -50%)

  .switcher__slider
    background-color: rgba($blue-2, 0.2)
    border-radius: @height
    cursor: pointer
    height: vw(14px)
    left: 0
    position: absolute
    top: 50%
    transform: translateY(-50%)
    transition: background-color 0.25s ease-in-out
    width: vw(30px)

    .mobile &
      height: vw(10px)
      width: vw(28px)

      +m-breakpoint(landscape)
        height: vw(7px)
        width: vw(18px)

    &:before
      background-color: #fff
      border-radius: 50%
      box-shadow: 0 0.5px 4px rgba(#000, 0.12), 0 6px 13px rgba(#000, 0.12)
      content: ""
      height: vw(22px)
      left: 0
      position: absolute
      top: 50%
      transform: translate(-25%, -50%)
      transition: all 0.25s ease-in-out
      width: vw(22px)

      .mobile &
        height: vw(20px)
        width: vw(20px)

        +m-breakpoint(landscape)
          height: vw(12px)
          width: vw(12px)
</style>
